import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errDetail } from "@/lib/api";

export default function ChangePassword({ className = "" }: { className?: string }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (f.next.length < 8) return toast.error("La nueva contraseña debe tener al menos 8 caracteres");
    if (f.next !== f.confirm) return toast.error("Las contraseñas no coinciden");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Contraseña actualizada");
      setOpen(false);
      setF({ current: "", next: "", confirm: "" });
    } catch (err) {
      toast.error(errDetail(err));
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="admin-change-password-btn" className={className}><KeyRound className="h-4 w-4" />Cambiar contraseña</button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Cambiar contraseña</DialogTitle>
          <DialogDescription>Mínimo 8 caracteres. Al guardar, se cerrarán las sesiones abiertas en otros dispositivos.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          <div className="space-y-1.5"><Label htmlFor="cp-current">Contraseña actual</Label><Input id="cp-current" type="password" required autoComplete="current-password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} data-testid="cp-current-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="cp-next">Nueva contraseña</Label><Input id="cp-next" type="password" required minLength={8} autoComplete="new-password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} data-testid="cp-new-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="cp-confirm">Confirmar nueva contraseña</Label><Input id="cp-confirm" type="password" required autoComplete="new-password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="cp-confirm-input" /></div>
          <button type="submit" disabled={saving} data-testid="cp-submit-btn" className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-[#0B192C] py-3 text-sm font-semibold text-white disabled:opacity-60">
            {saving && <Loader2 className="h-4 w-4 animate-spin" />}Guardar contraseña
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
